import { connect } from 'react-redux';

import AddUserToBuckets from '../../components/AddUserToBuckets';
import * as bucketConstants from '../../constants/buckets';

const mapDispatchToProps = dispatch => ({
    onSubmit: payload =>
        dispatch({
            type: bucketConstants.ADD_USERS_TO_BUCKETS_REQUEST,
            payload,
        }),
});

export default connect(
    undefined,
    mapDispatchToProps,
)(AddUserToBuckets);



// WEBPACK FOOTER //
// ./src/containers/appDialog/AddUserToOrganizationBuckets.js